import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import _ from 'lodash'

import RoleEntity from './components/RoleEntity'
import RoleTable from './components/RoleTable'
import Summary from './components/Summary'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class Role extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        clickedElement: PropTypes.object,
        customData: PropTypes.object,
        data: PropTypes.array,
        module: PropTypes.string,
        openSections: PropTypes.object.isRequired,
        pinnedIndex: PropTypes.string,
        pinParticipationElement: PropTypes.func.isRequired,
        roleSetClickedElement: PropTypes.func.isRequired,
        toggleRoleSection: PropTypes.func.isRequired,
        translates: PropTypes.shape({
            birthDateLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            activeSum: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            today: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            to: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            activeCompaniesLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            activeRolesLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            showAll: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            hideAll: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = { hoveredElement: {} }
    }

    handleOnHover = (attributes, click) => {
        const { module, data, block, customData, roleSetClickedElement } = this.props
        const subjectId = `${_.get(data, '[1].subject.id', null)}`

        if (click) {
            this.setState({ hoveredElement: attributes })
            roleSetClickedElement(module, subjectId, block, {
                ...customData,
                clickedElement: attributes,
            })
        }

        this.setState({ hoveredElement: attributes })
    }

    handleShowAllClick = () => {
        const { module, block, data, toggleRoleSection } = this.props

        const subjectId = `${_.get(data, '[1].subject.id', null)}`
        const tablesIndentifiers = _.map(_.get(data, '[1].table', []), (t, index) => `role-table-${index}`)

        const newCustomData = {
            openSections: _.reduce(
                tablesIndentifiers,
                (acc, val) => ({
                    ...acc,
                    [val]: true,
                }),
                {}
            ),
        }

        toggleRoleSection(module, subjectId, block, newCustomData)
    }

    handleHideAllClick = () => {
        const { module, block, data, toggleRoleSection } = this.props

        const subjectId = `${_.get(data, '[1].subject.id', null)}`

        const newCustomData = {
            openSections: {},
        }

        toggleRoleSection(module, subjectId, block, newCustomData)
    }

    render() {
        const {
            module,
            block,
            customData,
            clickedElement,
            data,
            pinParticipationElement,
            toggleRoleSection,
            openSections,
            pinnedIndex,
            translates: {
                today,
                activeSum,
                from,
                to,
                birthDateLabel,
                activeCompaniesLabel,
                activeRolesLabel,
                showAll,
                hideAll,
            },
        } = this.props

        const dataSummary = _.get(data, '0', {})
        const dataTable = _.get(data, '1', {})
        const subjectId = _.get(dataTable, 'subject.id', null)

        return (
            <div className={'role-wrap'}>
                <Summary
                    translates={{ activeCompaniesLabel, activeRolesLabel }}
                    activeCompanies={_.get(dataSummary, 'activeCompanies', 0)}
                    activeRoles={_.get(dataSummary, 'activeRolesTotal', 0)}
                />
                {!_.isEmpty(this.state.hoveredRange) && (
                    <div className={'hover-element'} style={{ left: this.state.hoveredRange.left - 330 }} />
                )}
                {!_.isEmpty(dataTable) && (
                    <RoleEntity
                        type={'primary'}
                        translates={{ birthDateLabel }}
                        mainId={`${subjectId}`}
                        module={module}
                        customData={customData}
                        block={block}
                        tableIdentifier={`entity-main-${subjectId}`}
                        entity={dataTable.subject}
                        toggleRoleSection={toggleRoleSection}
                        openSections={openSections}
                    />
                )}
                <div className={'role-controls'}>
                    <button type={'button'} className={'role-control-btn'} onClick={this.handleShowAllClick}>
                        {showAll}
                    </button>
                    <button type={'button'} className={'role-control-btn'} onClick={this.handleHideAllClick}>
                        {hideAll}
                    </button>
                </div>
                {_.map(_.get(dataTable, 'table', []), ({ subject, counters, indicators, roles }, key) => (
                    <div
                        key={`role-content-${key}`}
                        className={cx(
                            'role-content',
                            key === _.size(dataTable.table) - 1 && 'last',
                            key === 0 && 'first'
                        )}
                    >
                        <div className={'role-navigation-big'}>
                            <div className={cx('counter-element', _.get(counters, 'active') <= 0 && 'historical')}>
                                <span>
                                    {_.get(counters, 'active', 0)}/{_.get(counters, 'total', 0)}
                                </span>
                            </div>
                            <div className={cx('active-element', _.get(counters, 'active') <= 0 && 'historical')}>
                                {activeSum}
                            </div>
                        </div>
                        <div className={'role-entities-content'}>
                            <RoleEntity
                                type={'small'}
                                module={module}
                                customData={customData}
                                block={block}
                                translates={{ birthDateLabel }}
                                identifier={`entity-list-${subjectId}-1`}
                                tableIdentifier={`role-table-${key}`}
                                entity={subject}
                                indicators={indicators}
                                toggleRoleSection={toggleRoleSection}
                                mainId={`${subjectId}`}
                                openSections={openSections}
                            />
                            <RoleTable
                                module={module}
                                block={block}
                                customData={customData}
                                pinnedIndex={pinnedIndex}
                                roles={roles}
                                translates={{ today, from, to }}
                                mainId={`${subjectId}`}
                                dateRange={dataTable.dateRange}
                                tableIdentifier={`role-table-${key}`}
                                hoveredElement={this.state.hoveredElement}
                                clickedElement={clickedElement}
                                handleOnHover={this.handleOnHover}
                                pinParticipationElement={pinParticipationElement}
                                toggleRoleSection={toggleRoleSection}
                                openSections={openSections}
                            />
                        </div>
                    </div>
                ))}
            </div>
        )
    }
}
